import { Loader } from "@productlane/ui"

import { api } from "@/lib/api"

export function ApiErrorBreakdownChart() {
	const query = api.apiAnalytics.adminErrorBreakdown.useQuery({ days: 14 })

	return (
		<div className="rounded-lg border p-4">
			<h3 className="mb-3 text-sm font-medium text-gray-800 dark:text-white">
				Errors by code (last 14 days)
			</h3>
			{query.isLoading || !query.data ? (
				<div className="flex h-32 items-center justify-center">
					<Loader />
				</div>
			) : query.data.length === 0 ? (
				<div className="text-xs text-secondary">No errors.</div>
			) : (
				<div className="flex flex-col gap-1 text-xs">
					{query.data.map((row) => (
						<div
							key={row.errorCode}
							className="flex items-center justify-between gap-2"
						>
							<span className="truncate font-mono">{row.errorCode}</span>
							<span className="tabular-nums">{row.count.toLocaleString()}</span>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
